import gql from 'graphql-tag';

export const referralFragment = gql`
  fragment referralFragment on Referral {
    dokkioClass
    id
    referredAccountID
    referrerAccountID
    requirementsMetAt
    referredRedeemedAt
    referrerRedeemedAt
  }
`;
export default referralFragment;
